/**
 * features/quotes/useQuotes.ts
 * Live subscription to quotes, newest first.
 */
import { useEffect, useState } from 'react';
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { COLLECTIONS, type Quote } from '@/types';

export function useQuotes() {
  const [quotes, setQuotes] = useState<Quote[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, COLLECTIONS.quotes), orderBy('createdAt', 'desc'));
    return onSnapshot(
      q,
      (snap) => {
        setQuotes(snap.docs.map((d) => ({ id: d.id, ...(d.data() as Omit<Quote, 'id'>) })));
        setLoading(false);
      },
      () => setLoading(false),
    );
  }, []);

  return { quotes, loading };
}
